'use strict';

module.exports = function ( $cell, data ) {
    var $app        = document.createElement('div'),
        $normalBody = document.createElement('div'),
        $activeBody = document.createElement('div'),
        $lock       = document.createElement('div'),
        $normalIcon = document.createElement('div'),
        $activeIcon = document.createElement('div'),
        $name       = document.createElement('div'),
        $shadow     = document.createElement('div');

    $cell.className = 'grid__cell';
    // clear
    $cell.innerText = null;

    if ( data && !data.disable ) {
        $app.className = 'app';
        $lock.className = 'app__lock';
        $name.className = 'app__name';
        $normalBody.className = 'app__body';
        $activeBody.className = 'app__body active';
        $normalIcon.className = 'app__icon';
        $activeIcon.className = 'app__icon';
        $shadow.className = 'app__shadow';

        $normalBody.style.backgroundColor = $activeBody.style.backgroundColor = data.colors.splashBackground;
        $name.style.color = data.colors.splashFont;
        $name.innerText = data.name;
        $normalIcon.style.backgroundImage = 'url("' + data.icon + '")';
        $activeIcon.style.backgroundImage = 'url("' + data.focusIcon + '")';
        $lock.style.visibility = data.locked ? 'inherit' : 'hidden';

        $normalBody.appendChild($normalIcon);
        $normalBody.appendChild($shadow.cloneNode());
        $normalBody.appendChild($lock.cloneNode());
        $normalBody.appendChild($name.cloneNode(true));

        $activeBody.appendChild($activeIcon);
        $activeBody.appendChild($shadow);
        $activeBody.appendChild($lock);
        $activeBody.appendChild($name);

        $app.appendChild($normalBody);
        $app.appendChild($activeBody);
        $cell.appendChild($app);
    }
};
